export const mssgs = {
  NADA_QUE_MOSTRAR_AÑADIR_UNIDADES_NEGOCIO:
    "Nada que visualizar. Añade o crea Unidades de Negocio para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_TAREA: "Nada que visualizar. Añade o crea leads para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_PRESENTACION:
    "Nada que visualizar. Añada o crea presentaciones para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_PRODUCTOS: "Nada que visualizar. Añada o crea productos para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_CONTACTOS: "Nada que visualizar. Añada o crea contactos para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_HOSPITALES: "Nada que visualizar. Añada o crea hospitales para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_CARGOS: "Nada que visualizar. Añada o crea cargos para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_DEPARTAMENTOS:
    "Nada que visualizar. Añada o crea departamentos para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_ESPECIALIDADES_MEDICAS:
    "Nada que visualizar. Añada o crea especialidades médicas para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_USUARIOS: "Nada que visualizar. Añada o crea usuarios para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_CATEGORIAS: "Nada que visualizar. Añada o crea categorías para mostrar.",
  NADA_QUE_MOSTRAR_AÑADIR_PRODUCTOS_PRESENTACION:
    "Nada que visualizar. Añada producto a la presentación para mostrar.",
  NO_HAY_PRODUCTOS: "No hay productos que mostrar.",
  DELETE_RECORD_SUCCESSFULLY: "Se ha eliminado el registro con éxito",

  NADA_QUE_MOSTRAR_AÑADIR_EVENTO: "Nada que visualizar. Añade o crea eventos para mostrar.",
};
